import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* eslint-disable */
import { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import Region from 'region';
import DragHelper from 'drag-helper';
import toStringValue from './toStringValue';
export var baseInitialState = {
  top: 0,
  left: 0,
  mouseDown: null
};
export var basePropTypes = {
  inPicker: PropTypes.bool,
  onMouseDown: PropTypes.func,
  onDrag: PropTypes.func,
  onChange: PropTypes.func
};
export var baseDefaultProps = {
  inPicker: false,
  onMouseDown: null,
  onDrag: null,
  onChange: null
};

var getEventInfo = function getEventInfo(event, region) {
  var x = event.clientX - region.left;
  var y = event.clientY - region.top;
  return {
    x: x,
    y: y,
    width: region.getWidth(),
    height: region.getHeight()
  };
};

var BaseComponent = /*#__PURE__*/function (_Component) {
  _inherits(BaseComponent, _Component);

  var _super = _createSuper(BaseComponent);

  function BaseComponent() {
    var _this;

    _classCallCheck(this, BaseComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", baseInitialState);

    _defineProperty(_assertThisInitialized(_this), "rootRef", /*#__PURE__*/createRef());

    _defineProperty(_assertThisInitialized(_this), "handleDragStart", Function.prototype);

    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (event) {
      event.preventDefault();

      var region = _this.getDOMRegion();

      var info = getEventInfo(event, region);
      DragHelper(event, {
        scope: _assertThisInitialized(_this),
        constrainTo: region,

        /* eslint-disable no-param-reassign */
        onDragStart: function onDragStart(dragStartEvent, config) {
          config.initialPoint = info;
          config.minLeft = 0;
          config.maxLeft = region.width;
          this.handleDragStart(dragStartEvent);
        },

        /* eslint-enable no-param-reassign */
        onDrag: function onDrag(dragEvent, config) {
          var dragInfo = getEventInfo(dragEvent, region);
          var newHsv = this.updateColor(dragInfo);
          this.handleDrag(dragEvent, config, newHsv);
        },
        onDrop: function onDrop(dropEvent, config) {
          var dropInfo = getEventInfo(dropEvent, region);
          var newHsv = this.updateColor(dropInfo);
          this.handleDrop(dropEvent, config, newHsv);
        }
      });

      _this.updateColor(info);

      _this.handleMouseDown(event, {
        initialPoint: info
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseDown", function (event, config) {
      var onMouseDown = _this.props.onMouseDown;

      if (onMouseDown) {
        onMouseDown.apply(_assertThisInitialized(_this), _this.getColors(_this.hsv));
      }

      _this.handleDrag(event, config, _this.hsv);
    });

    return _this;
  }

  _createClass(BaseComponent, [{
    key: "getDOMRegion",
    value: function getDOMRegion() {
      return Region.fromDOM(this.rootRef.current);
    }
  }, {
    key: "getColors",
    value: function getColors(hsv) {
      var inPicker = this.props.inPicker;
      var first = inPicker ? hsv : toStringValue(hsv);
      var args = [first];

      if (!inPicker) {
        args.push(_objectSpread({}, hsv));
      }

      return args;
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(event, config) {
      var diff = config.diff || {
        top: 0,
        left: 0
      };
      var initialPoint = config.initialPoint;

      if (initialPoint) {
        var left;
        left = initialPoint.x + diff.left;
        var top = initialPoint.y + diff.top;
        left = Math.max(left, config.minLeft);
        left = Math.min(left, config.maxLeft);
        this.setState({
          top: top,
          left: left,
          mouseDown: {
            x: left,
            y: top,
            width: initialPoint.width,
            height: initialPoint.height
          }
        });
      }
    }
  }, {
    key: "handleDrag",
    value: function handleDrag(event, config, hsv) {
      var onDrag = this.props.onDrag;
      this.handleUpdate(event, config);

      if (onDrag) {
        onDrag.apply(this, this.getColors(hsv));
      }
    }
  }, {
    key: "handleDrop",
    value: function handleDrop(event, config, hsv) {
      var onChange = this.props.onChange;
      this.handleUpdate(event, config);
      this.setState({
        mouseDown: false
      });

      if (onChange) {
        onChange.apply(this, this.getColors(hsv));
      }
    }
  }]);

  return BaseComponent;
}(Component);

_defineProperty(BaseComponent, "propTypes", basePropTypes);

_defineProperty(BaseComponent, "defaultProps", baseDefaultProps);

export default BaseComponent;